import { Injectable, inject, signal } from '@angular/core';
import { UserAccountApiService } from './user-account-api.service';
import { isSuperAdminRoleSlug } from '../constants/super-admin-role';

export interface AdminProfileRole {
  id?: number;
  role_name?: string;
  slug?: string;
}

@Injectable({ providedIn: 'root' })
export class AdminAccessService {
  private readonly userAccountApi = inject(UserAccountApiService);

  readonly isSuperAdmin = signal(false);
  readonly profileLoaded = signal(false);

  /** Loads admin profile once and caches whether the user has the Super Admin role. */
  ensureProfileLoaded(): void {
    if (this.profileLoaded()) return;

    this.userAccountApi.getAdminProfile().subscribe({
      next: (res) => {
        const roles =
          (res?.data as { user_roles?: { role?: AdminProfileRole }[] } | undefined)
            ?.user_roles ?? [];
        const hasSuperAdmin = roles.some((ur) =>
          isSuperAdminRoleSlug(ur?.role?.slug),
        );
        this.isSuperAdmin.set(hasSuperAdmin);
        this.profileLoaded.set(true);
      },
      error: () => {
        this.isSuperAdmin.set(false);
        this.profileLoaded.set(true);
      },
    });
  }
}
